// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qd-1";
export var stateContainer = "_qd-0";